import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    processing: Boolean,
    resyncUrl: String,
    streamSourceId: String,
  }

  connect() {
    this.lastConnected = false
    this.resyncInFlight = false
    this.boundHandleMutation = this.handleMutation.bind(this)

    if (!this.processingValue) return
    if (!this.hasResyncUrlValue || !this.hasStreamSourceIdValue) return

    this.streamSource = document.getElementById(this.streamSourceIdValue)
    if (!this.streamSource) return

    this.observer = new MutationObserver(this.boundHandleMutation)
    this.observer.observe(this.streamSource, {
      attributes: true,
      attributeFilter: ["connected"],
    })

    this.lastConnected = this.streamSource.hasAttribute("connected")
    if (this.lastConnected && !this.streamSource.dataset.invoiceClassificationSyncBootstrapped) {
      this.streamSource.dataset.invoiceClassificationSyncBootstrapped = "true"
      this.requestResync()
    }
  }

  disconnect() {
    this.teardownObserver()
  }

  handleMutation(mutations) {
    const connectionAttributeChanged = mutations.some(
      (mutation) =>
        mutation.type === "attributes" &&
        mutation.attributeName === "connected",
    )
    if (!connectionAttributeChanged) return

    const connected = this.streamSource.hasAttribute("connected")
    if (connected && !this.lastConnected) this.requestResync()

    this.lastConnected = connected
  }

  async requestResync() {
    if (this.resyncInFlight) return
    this.resyncInFlight = true

    try {
      const response = await fetch(this.resyncUrlValue, {
        credentials: "same-origin",
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      if (!response.ok) return

      const streamMessage = await response.text()
      Turbo.renderStreamMessage(streamMessage)
    } catch (error) {
      void error
      // no-op: websocket updates still apply for subsequent broadcasts
    } finally {
      this.resyncInFlight = false
    }
  }

  teardownObserver() {
    if (!this.observer) return

    this.observer.disconnect()
    this.observer = null
  }
}
